
CheckoutV2.Payment.StoredCreditCard = function(checkout, payment, storedPayment, isReview) {
    var _scc = this;

    var $wrap;
	this.noDisplayCombo = ['paypal']; // don't even display the add-multi option

    var storedPaymentID = false;
	
	var addError = false;
	var prefix = '';
	if (isReview)
		prefix = 'review-';



    var init = function() {
        
        if (storedPayment) {
            storedPaymentID = storedPayment.method.split('-')[1];
        }

        if (!storedPaymentID) {
            _scc.addError = 'Failed to retrieve Stored Credit Card info';
            return;
        }

        // Do not allow stored card to be used more than once on the order
        
        
        if ( jQuery.grep(payment.getData(), function( scc ) { return scc.method == storedPayment.method; }).length > 0 ) {
        	_scc.addError = creditCardTypes[storedPayment.cardType].label + ' ending in ' + storedPayment.cardLast4 + ' already added';
        	return;
        }
        
        if (getContainer().children().length == 6) {
            _scc.addError = 'Maximum of 6 Credit Cards Allowed';
            return;
        }

        buildContent();
        publish();
    };

    var publish = function() {
        _scc.$wrap = $wrap;
        _scc.label = 'Credit Card';
        _scc.getContainer = getContainer;
        _scc.afterRemoved = afterRemoved;
        _scc.getStoredPaymentID = getStoredPaymentID;
        _scc.getStoredPayment = getStoredPayment;
        _scc.getData = getData;
        _scc.afterShow = afterShow;
        _scc.addError = addError;
    };

	this.publish = publish;

    var buildContent = function() {
        
        $wrap = $($.parseHTML(Jemplate.process('includes/partials/payment/storedCreditCard.html', {
            card_last_four: storedPayment.cardLast4,
            card_expire_month: ((storedPayment.expMonth + '').length == 1 ? '0' : '') + storedPayment.expMonth,
            card_expire_year: (storedPayment.expYear + '').slice(-2),
            card_type: storedPayment.cardType,
            first_name: storedPayment.firstName,
            last_name: storedPayment.lastName,
            address: storedPayment.address,
            city: storedPayment.city,
            state: storedPayment.state,
            zip: storedPayment.zip,
            CDNstatic: CDNpath,
        }))); 
    }

    this.buildReview = function() {
        var card = storedPayment;
        var data = {
                    method: 'creditcard',
					method_name: _scc.label,
                    card_type: card.cardType,
                    card_last_four: card.cardLast4,
                    card_expire_month: ((card.expMonth + '').length == 1 ? '0' : '') + card.expMonth,
                    card_expire_year: (card.expYear + '').slice(-2),
                    first_name: card.firstName,
                    last_name: card.lastName,
                    address: card.address,
                    city: card.city,
                    state: card.state,
                    zip: card.zip,
					payment_amount: checkout.payment.getMethodAmt( _scc ),
                };
		return data;
    };


    var getContainer = function() {
        if (!payment.creditCardWrap)
            payment.creditCardWrap = new CheckoutV2.Payment.CreditCardWrap(checkout, payment, isReview);

        return payment.creditCardWrap.$container;
    };

    var afterRemoved = function() {
        /*
        if (!getContainer().children().length) {
            payment.creditCardWrap.remove();
            payment.creditCardWrap = false;
        }
        */
    };

    var getStoredPaymentID = function() {
        return storedPaymentID;
    }
	
	var getStoredPayment = function() {
		return storedPayment;
	}

    var getData = function() {
        return {
            'storedPaymentID': storedPaymentID,
        };
    };
	
	var afterShow = function() {
		_scc.$wrap.find('.card-address[data-toggle="popover"]').popover();
		
		_scc.$wrap.find('.js-change-credit-card').off('click');
		_scc.$wrap.find('.js-change-credit-card').on('click', function(){
			var methodKey = $(this).parents('.payment-method').data('methodKey');
			var card_list = [];
			$.each(checkout.session.get('storedPayments'), function(i, card) {
				card_list.push({
					id: card.method.split('storedcreditcard-')[1],
					type: card.cardType,
					last_four: card.cardLast4,
					expire_month: ((card.expMonth + '').length == 1 ? '0' : '') + card.expMonth,
					expire_year: (card.expYear + '').slice(-2),
					first_name: card.firstName,
					last_name: card.lastName,
					address: card.address,
					address2: card.address2,
					city: card.city,
					state: card.state,
					zip: card.zip,
					country: card.country,
					billID: card.billID,
				});
			});
			$('#changeCreditCardModal .js-credit-card-list').html(
				Jemplate.process('includes/partials/payment/creditCardList.html', {
					current_card: getStoredPaymentID(),
					card_list: card_list,
				})
			);
			
			$('#changeCreditCardModal').modal('show');
			
			$('#changeCreditCardModal .js-credit-card-list .card-address[data-toggle="popover"]').popover();
			
			//$('#changeCreditCardModal .js-credit-card-list .js-edit-credit-card').on('click', function(){
			//	$('#editCreditCardModal').modal('show');
			//});
			
			//$('#changeCreditCardModal .js-credit-card-list .js-delete-credit-card[data-toggle=confirmation]').confirmation({
			//	rootSelector: '[data-toggle=confirmation]',
			//	buttons: [
			//		{
			//			class: 'btn btn-danger',
			//			label: 'Yes',
			//			value: 'Yes',
			//		},
			//		{
			//			class: 'btn btn-medium',
			//			label: 'No',
			//			cancel: true,
			//		}
			//	],
			//});
			
			$('#changeCreditCardModal .js-add-credit-card').off('click');  // remove credit card listener, just in case
			$('#changeCreditCardModal .js-add-credit-card').on('click', function(){
				$('#addCreditCardModal .credit-card-alert .msg-text').html('');
				$('#addCreditCardModal .credit-card-alert').hide();
				$('#addCreditCardModal').modal('show');
				$('#addCreditCardModal .replaceMethodKey').val(methodKey);
			});
			
			
			$('#changeCreditCardModal .js-change-credit-card-btn').off('click');  // remove credit card listener, just in case
			$('#changeCreditCardModal .js-change-credit-card-btn').on('click', function(){
				var $selected = $('#changeCreditCardModal .js-credit-card-list input[type=radio]:checked');
				if ($selected && $selected.attr('id')) {
					if ($selected.attr('id') != getStoredPaymentID()) {
                        var previousPayment = payment.methods[ methodKey ];
                        var previousPaymentAmount = payment.getMethodAmt( previousPayment );
						payment.removeMethod(methodKey, false, true);

                        var newKey = "storedcreditcard-" + $selected.attr( "id" );
						payment.addMethod( newKey, previousPaymentAmount, true );
					}
					$('#changeCreditCardModal').modal('hide');
				}
			});
		});
	};

    init();
};

